/// <amd-module name="Wit/Common/BacklogToolpaneExtension/BacklogToolpaneExtension" />
import * as React from "react";
import { WrappedComponent } from "VSS/Platform/Layout";
import { Header } from "VSSUI/Header";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import * as Resources from "Wit/Common/BacklogToolpaneExtension/Resources";

export interface IBacklogToolpaneExtensionProps {
    title: string;
    team: {
        id: string;
        name: string;
    };
    contributionId: string | undefined;
    onDismiss: () => void;
}

export function BacklogToolpaneExtension(props: IBacklogToolpaneExtensionProps) {
    return (
        <div className="flex-column full-height" data-elementtype="side-panel-container">
            <Header title={props.title} commandBarItems={getHeaderCommandBarItems(props.onDismiss)} />
            <WrappedComponent
                key={props.contributionId}
                dependencies={["ms.vss-web.legacy-content", "ms.vss-web.legacy-vss-ui-content"]}
                wrappedType="legacy"
                wrappedProps={{
                    componentType: "vssLegacyContributionContentHost",
                    modules: ["VSSPreview/Providers/ContentHost"],
                    wrappedProps: {
                        className: "flex-grow v-scroll-auto full-height",
                        context: {
                            team: props.team
                        },
                        contribution: props.contributionId,
                        expectRegisteredInstance: true
                    }
                }}
            />
        </div>
    );
}

function getHeaderCommandBarItems(onDismiss: () => void): IHeaderCommandBarItem[] {
    return [
        {
            ariaLabel: Resources.Close,
            iconProps: { iconName: "Clear" },
            id: `contributed-pane-close-button`,
            role: "button",
            onActivate: onDismiss,
            subtle: true
        }
    ];
}
